import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-form-field-player-info',
  templateUrl: './player-info-form-field.component.html',
  standalone: false,
})
export class PlayerInfoFormFieldComponent extends DataTypeComponent {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: PlayerInfoFieldDTO;

  @Input() editMode: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  navigate(url: string) {
    this.router.navigate([url], { relativeTo: this.route.parent });
  }
}

export interface PlayerInfoFieldDTO {
  playerStatus: string;
  playerId: number;
  email: string;
}
